export const FILTER_ERROR_MESSAGE = "Please select at least one option for all the selected filters";
export const SIGN_IN_INVALID_CREDS_MESSAGE = "Invalid username / password";
export const FORGOT_PASSWORD_INVALID_CREDS_MESSAGE = "Email not exists";
export const FORGOT_PASSWORD_VALID_CREDS_MESSAGE = "Email sent successfully";
export const RESET_PASSWORD_VALID_CREDS_MESSAGE = "Password updated successfully";
export const RESET_PASSWORD_INVALID_CREDS_MESSAGE = "Cannot reset password";
export const USER_UNAUTHROIZED_MESSAGE = "User is not authorized to access this resource with an explicit deny";
export const SEARCH_ERROR_MESSAGE = "Please enter the search value";
